<template>
  <div class="statistics px-4">
    <h2 class="main-title">{{ lang == "en" ? "Statistics" : "Statistika" }}</h2>
    <div class="main-container d-flex flex-wrap">
      <div class="statistics-graph d-flex" v-if="countByBreed && countByBreed.length">
        <graph-pie
          :width="width"
          :height="height"
          :padding-top="70"
          :padding-bottom="100"
          :padding-left="70"
          :padding-right="70"
          :values="values"
          :names="names"
          :active-index="[0, 2]"
          :active-event="'click'"
          :show-text-type="'outside'"
          :data-format="dataFormat"
        >
          <legends :names="names"></legends>
          <tooltip :names="names"></tooltip>
        </graph-pie>
        <div class="resultContainer">
          <div class="d-flex justify-space-between">
            <p class="font-weight-bold white--text">Vrsta</p>
            <p class="font-weight-bold white--text">Br. pregleda</p>
          </div>
          <v-divider color="white"></v-divider>
          <!-- <div
            class="d-flex justify-space-between"
            v-for="(breed, index) in countByBreed"
            :key="index"
          >
            <p>{{ breed.type }}</p>
            <p>{{ breed.count }}</p>
          </div>
        </div> -->
        <div class="d-flex flex-wrap">
          <div style="flex: 0 0 50%;">
          <div
            class="d-flex justify-start"
            v-for="(breed, index) in names"
            :key="index"
          >
            <p>{{ breed }}</p>
          </div>
          </div>
          <div style="flex: 0 0 50%;">
          <div
            class="d-flex justify-end"
            style="flex: 0 0 50%;"
            v-for="(breed, index) in values"
            :key="index"
          >
            <p style="text-align: right;">{{ breed }}</p>
          </div>
          </div>
        </div>
        </div>
      </div>
      <div class="statistics-graph-q">
        <div class="mb-2">
          <div class="statistics">
            <h4>Zarada za izabrani dan</h4>
            <p class="price">{{ pricePerDateValue }}din</p>
            <div>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="pricePerDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="pricePerDate"
                    label="Izaberite datum"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="pricePerDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="pickPricePerDay(pricePerDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>
      </div>
      <div class="statistics-graph-q">
        <div class="mb-2">
          <div class="statistics">
            <h4>Zarada za izabrani mesec</h4>
            <p class="price">{{ pricePerMonthValue }}din</p>
            <div>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="pricePerMonth"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="pricePerMonth"
                    label="Izaberite mesec"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="pricePerMonth"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu1 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="pickPricePerMonth(pricePerMonth)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";

export default {
  name: "Settings",
  data() {
    return {
      values: [],
      names: [],
      menu: false,
      menu1: false,
      pricePerDate: moment(new Date()).format("YYYY-MM-DD"),
      pricePerMonth: moment(new Date()).format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState(["lang", "countByBreed", "IDcompany", "pricePerDateValue", "pricePerMonthValue"]),
    ...mapGetters(["rules"]),
    width() {
      return window.innerWidth < 768 ? window.innerWidth - 30 : 400;
    },
    height() {
      return 400;
    }
  },
  methods: {
    dataFormat: function (a, b) {
      var sum = this.values.reduce((a, b) => a + b);
      if (b) return ((100 / sum) * b).toFixed(2) + "%";
      return a;
    },
    pickPricePerDay(pricePerDate) {
      this.$refs.menu.save(moment(pricePerDate).format("YYYY-MM-DD"));
      var obj = {
        date: this.pricePerDate,
        companyId: this.IDcompany
      }
      this.$store.dispatch('getPriceSumForDay', obj)
    },
    pickPricePerMonth(pricePerMonth) {
      this.$refs.menu1.save(moment(pricePerMonth).format("YYYY-MM-DD"));
      var obj = {
        date: this.pricePerMonth,
        companyId: this.IDcompany
      }
      this.$store.dispatch('getPriceSumForMonth', obj)
    },
  },
  mounted() {
    var obj = {
      date: this.pricePerDate,
      companyId: this.IDcompany
    }
    this.$store.dispatch('getPriceSumForDay', obj)
    this.$store.dispatch('getPriceSumForMonth', obj)
    this.$store.dispatch("getCountByBreed");
    setTimeout(() => {
      var count = [];
      var names = [];
      this.countByBreed.forEach((element) => {
        if (names.includes(element.type.toLowerCase())) {
          var index = names.indexOf(element.type);
          count[index] = count[index] + element.count
        } else {
          count.push(element.count);
          names.push(element.type.toLowerCase());
        }
      });
      // this.countByBreed.forEach((element) => {
      //   count.push(element.count);
      //   names.push(element.type);
      // });
      this.values = count;
      this.names = names;
    }, 1000);
  },
};
</script>

<style lang="scss">
.price {
  font-size: 20px;
  color: #39c1de!important;
  font-weight: bold;
}
.main-container {
  svg {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background: $bg2;
  }
  text {
    fill: $inputColor;
  }
  .widget-tooltip text {
    fill: #000 !important;
  }
  .resultContainer {
    padding: 20px;
    flex-grow: 1;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: $bg2;
    margin-bottom: 5px;
    .d-flex {
      align-items: baseline;
      p {
        margin-bottom: 0;
      }
      > p:nth-child(1) {
        text-align: left;
        width: 50%;
        font-size: 15px;
      }
      > p:nth-child(2) {
        text-align: right;
        width: 120px;
        color: #39c1de;
        font-size: 15px;
      }
    }
  }
  .statistics-graph {
    width: 50%;
  }
  .statistics-graph-q {
    width: 25%;
    padding: 0 10px;
  }
  .statistics {
    background: $bg2;
    padding: 10px;
    border-radius: 4px;
  }
}

@media (max-width: 1355px) {
  .main-container {
    .statistics-graph {
      width: 100%;
      flex: 0 0 100%;
    }
    .statistics-graph-q {
      width: 100%;
      flex: 0 0 100%;
      padding: 0;
    }
  }
}

@media (max-width: 768px) {
  .statistics-graph {
    flex-direction: column;
  }

  .main-container {
    svg {
      border-radius: 4px;
    }
    .resultContainer {
      padding: 10px;
      border-radius: 4px;
      flex: 0 0 100%;
      width: 100%;
      .d-flex {
        align-items: flex-end;
        > p:nth-child(1) {
          width: 50%;
        }
        > p:nth-child(2) {
          width: 50%;
        }
      }
    }
  }
}
</style>